import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_ORDER_LOCALIZED = defineFcm('psf_share_order_localized')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Localized share order: kill-switch + experiment binding for reordering the social share-channel grid per country on the PSF promote_or_share share slide-up.',
		import: false,
		template: {
			enabled: false,
			experimentName: 'psf_share_order_localized_experiment',
		},
		deprecated:
			'FCM no longer in use — sibling experiment psf_share_order_localized_experiment concluded 2026-08-21 (CHANGE-98268). Cleanup cron will open the deletion PR once this has been deprecated and untouched in git for 14 days.',
	});
